const RadioChip = ({
  value,
  onChange,
  selected = false,
  children,
  className = "",
  disabled = false,
  "data-testid": dataTestId = "radio-chip",
}: {
  value: number;
  selected?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  "data-testid"?: string;
}) => {
  // [&_input:checked+div]: & = this element, '_' tailwind translates to a space ' ', input:checked = checked input, +div = neighboring div
  // for more info on this tailwind pattern: https://tailwindcss.com/docs/adding-custom-styles#using-arbitrary-values
  const checkedClasses =
    "[&_input:checked+div]:border-2 [&_input:checked+div]:border-grey";
  const disabledClasses = "[&_input:disabled+div]:bg-leafly-white";
  const enabledClasses = "[&_input:enabled+div]:cursor-pointer";

  return (
    <label
      className={`${enabledClasses} ${disabledClasses} ${checkedClasses} ${className}`}
      data-testid={dataTestId}
    >
      <input
        type="radio"
        value={value}
        onChange={onChange}
        checked={selected}
        className="hidden"
        disabled={disabled}
      />
      <div className="flex flex-col p-4 border-light-grey border rounded text-charcoal">
        {children}
      </div>
    </label>
  );
};

export default RadioChip;
